<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('benefitDetail') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId" >
                        {{ assetTypeName || $t('assetType') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ data.name }}</li>
            </ol>
        </nav>
        <div class="row mb-4">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="name" required>{{ $t('name') }}</label>
                <input v-model="data.name" type="text" class="form-control" id="name" >
            </div>
              <div class="mb-3 col-md-8">
                <label class="form-label" for="description" required>{{ $t('description') }}</label>
                <input v-model="data.description" type="text" class="form-control" id="description">
            </div>
        </div>
        <button class="fa fa-table btn btn-outline-primary float-end" @click="showBenefitCalculationModal = true"></button>
        <div class="mb-4">
            <h4>{{ $t('benefitAttributes') }}</h4>
            <table class="table ">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ $t('name') }}</th>
                        <th scope="col">{{ $t('weight') }}</th>
                        <th scope="col">{{ $t('biggerMoreBenefit') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(benefitAttribute, i) in data.benefitAttributes" class="align-middle"  :key="i" >
                        <th scope="row"><i class="fa fa-remove" @click="removeBenefitAttribute(i)"></i></th>
                        <td>
                            <select class="form-select" v-model="benefitAttribute.name" :aria-placeholder="benefitAttribute.name">
                                <option disabled>{{ $t('select') }}</option>
                                <template v-if="datasetHeaders.length > 0" >
                                    <option v-for="(datasetHeader, i) in datasetHeaders" :key="i"  v-bind:value="datasetHeader.name">{{ datasetHeader.alias }}</option>
                                </template>
                                <template v-if="missingDatasetHeaders.length > 0" >
                                    <option v-for="(missingDatasetHeader, i) in missingDatasetHeaders" :key="i" disabled  v-bind:value="missingDatasetHeader.name">{{ missingDatasetHeader.alias }}</option>
                                </template>
                            </select>
                        </td>
                        <td>
                            <input v-model="benefitAttribute.weight" type="number" class="form-control" :id="'weight_' + i">
                        </td>
                        <td>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" v-model="benefitAttribute.biggerMoreBenefit" :id="'biggerMoreBenefit_' + i" checked>
                            
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-secondary w-25 mx-auto d-block"  @click="addBenefitAttribute"><i class="fa-solid fa-plus"></i></button>
        </div>
        <div class="d-grid gap-2 d-md-flex ">
            <template v-if="isUserAdmin">
                <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('save') }}</button>
                <button type="button" class="btn btn-danger" @click="showDeleteBenefit">{{ $t('delete') }}</button>
            </template>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}` })">{{ $t('back') }}</button>
        </div>
        <BenefitDeleteModal v-if="showBenefitDeleteModal" @reload="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}` })" @closeDeleteDialog="showBenefitDeleteModal = false"/>
        <BenefitCalculationModal v-if="showBenefitCalculationModal" @closeDeleteDialog="showBenefitCalculationModal = false"/>
    </div>
</template>

<script>
import BenefitApi from "../../api/server/benefit";
import DatasetApi from "../../api/server/dataset";
import AssetTypeApi from "../../api/server/assetType";
import ModelingApi from "../../api/server/modeling";
import BenefitDeleteModal from '../benefits/BenefitDeleteModal.vue';
import BenefitCalculationModal from '../benefits/BenefitCalculationModal.vue';
import CheckIfUserIsAdmin from '../../authCache';

export default {
    name: "benefitDetail",
    watch: {
        $route: "requestData",
    },
    mounted() {
        this.requestData();
    },
    components: {
        BenefitDeleteModal,
        BenefitCalculationModal
    },
    methods: {
        async requestData() {
            this.pending = true;
            this.isUserAdmin = await CheckIfUserIsAdmin();
            
            var modelingInfo = await ModelingApi.modelingInfo(this.$route.params.id);
            for(var i in modelingInfo.selections) {
                var selection = modelingInfo.selections[i];
                for(var o in selection.packages) {
                    var selectionPackage = selection.packages[o];
                    var exists = selectionPackage.lifeCycles.find(lifeCycle => lifeCycle.benefitId == this.$route.params.benefitId);
                    if(exists) {
                        this.foundBenefits.push({ 
                            selectionId: selection.id,
                            selectionPackageId: selectionPackage.id,
                            name: "Selection - " + selection.name + " - " + selectionPackage.name
                        });
                    }
                }
            }

            this.data = await BenefitApi.benefitDetail(this.$route.params.id, this.$route.params.benefitId);
            var assetType = await AssetTypeApi.assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;

            var dataset = await DatasetApi.datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];

            for(var i in this.data.benefitAttributes) {
                var attr = this.data.benefitAttributes[i];
                if(this.datasetHeaders.findIndex(d => d.name == attr.name) < 0 && this.missingDatasetHeaders.findIndex(d => d.name == attr.name) < 0) {
                    this.missingDatasetHeaders.push({ name: attr.name, alias: attr.name });
                }
            }

            this.pending = false;
        },
        async onSubmit() {
            if(this.data.name.length > 0) {
                await BenefitApi.benefitUpdate(this.$route.params.id, this.data);

                if(!this.isFormValid())
                    this.showWarning();
                else 
                    this.showSuccess();
            } else {
                this.showEmptyNameError();
            }
        },
        isFormValid() {
            for(var i in this.data.benefitAttributes) {
                var attr = this.data.benefitAttributes[i];
                if(this.datasetHeaders.findIndex(d => d.name == attr.name) < 0 || attr.name == "")
                    return false;
            }

            return true
        },
        addBenefitAttribute() {
            this.data.benefitAttributes.push({ name: "", biggerMoreBenefit: false, weight: 0 })
        },
        removeBenefitAttribute(rowIndex) {
            this.data.benefitAttributes.splice(rowIndex, 1);
        },
        showDeleteBenefit() {
            this.benefitToDeleteId = this.data.id;
            this.showBenefitDeleteModal = true;
        } 
    },
    notifications: {
        showSuccess: { 
            title: 'success',
            message: 'benefitUpdated',
            type: 'success'
        },
        showWarning: {
            title: 'warning',
            message: 'warningAttributeRemoved',
            type: 'warn'
        },
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    },
    data() {
        return {
            datasetHeaders: [],
            missingDatasetHeaders: [],
            data: {
                name: "",
                benefitAttributes: [
                    {
                        name: "",
                        weight: 0,
                        biggerMoreBenefit: false
                    }
                ],
                id: 0
            },
            benefitToDeleteId: 0,
            showBenefitDeleteModal: false,
            showBenefitCalculationModal: false,
            modelingName: null,
            assetTypeName: null,
            pending: true,
            foundBenefits: [],
            isUserAdmin: false
        }
    }
};
</script>